import * as React from 'react'
import { useDispatch } from 'redux-react-hook'
import { Redirect } from 'react-router-dom'
import { setPage } from '../../../actions/header.action'
import { setDayReportLogs } from '../../../actions/report.action'
import {
  getPatientDetails,
  getPatientShared,
} from '../../../actions/patient.action'
import { Header } from '../..//molecules/header'
import styled from 'styled-components'
import { Size } from '../../../constants/app.constant'
import Contents from './contents'
import * as HeaderConst from '../../../constants/header.constant'
import useGetState from '../../../hooks/use-get-state'
import useFetchApi from '../../../hooks/use-fetch-api'
const { useEffect } = React
const Report: React.SFC = () => {
  const dispatch = useDispatch()
  const {
    state: { auth, routing },
  } = useGetState()
  const { isLoading, response } = useFetchApi({
    method: 'GET',
    url: `patients/${
      auth.user.idToken.payload['custom:userId']
    }/dayTrainingLogs`,
  })
  useEffect(
    () => {
      document.title = '運動レポート画面'
      dispatch(setPage(HeaderConst.HEADER_REPORT))
      dispatch(
        getPatientDetails({
          patientId: auth.user.idToken.payload['custom:userId'],
          jwtToken: auth.user.idToken.jwtToken,
        })
      )
    },
    [auth.user.idToken.jwtToken, auth.user.idToken.payload, dispatch]
  )
  useEffect(
    () => {
      if (response) {
        dispatch(setDayReportLogs(response))
        dispatch(
          getPatientShared({
            patientId: auth.user.idToken.payload['custom:userId'],
            jwtToken: auth.user.idToken.jwtToken,
          })
        )
      }
    },
    [auth.user.idToken.jwtToken, auth.user.idToken.payload, dispatch, response]
  )
  if (routing.location.pathname.match('inquiry')) {
    return (<Redirect to="/inquiry" />)
  } 
  return (
    !isLoading && (
      <Wrapper>
        <Header />
        <Contents />
      </Wrapper>
    )
  )
}
export default Report
const Wrapper = styled.div`
  max-width: ${Size.BREAK_POINT.MOBILE}px;
  background: white;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/components/pages/report/report.tsx